// Lazy registry for a multi-region bundle's PART DRIVE — the rig whose bones deform the
// gaussians. Notes: ~/comments/aos-threejs-poc/partDriveRegistry_macarena_gating.md

const state = { build: null, drive: null, building: null }

/** Register a bundle's part drive. `build` runs at most once, on demand. */
export function register({ build }) {
  state.build = typeof build === 'function' ? build : null
  state.drive = null
  state.building = null
}

/** Forget the registration. A character switch disposes the scene under the builder. */
export function reset() {
  register({ build: null })
}

export function isAvailable() { return !!state.build }

/** The drive handle, or null when the bundle has none or the build failed (logged). One
 *  build however many consumers ask — the in-flight promise is shared. */
export async function build() {
  if (!state.build) return null
  if (state.drive) return state.drive
  state.building = state.building || state.build()
  try {
    state.drive = await state.building
  } catch (e) {
    console.error('[ogs] part drive build failed:', e)
    return null
  } finally {
    state.building = null
  }
  return state.drive ?? null
}

export const partDriveRegistry = { register, reset, build, isAvailable }
